import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const WORKFLOWS_PATH = '/api/workflows';
const WEBHOOKS_PATH = '/api/webhooks';

const createWorkflow = async (workflowData) => {
  const response = await axios.post(`${API_BASE_URL}${WORKFLOWS_PATH}`, workflowData);
  return response.data.data;
};

const getWorkflows = async () => {
  const response = await axios.get(`${API_BASE_URL}${WORKFLOWS_PATH}`);
  return response.data.data;
};

// --- NEW FUNCTION ---
const getWorkflowById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}${WORKFLOWS_PATH}/${id}`);
  return response.data.data;
};

// --- NEW FUNCTION ---
const updateWorkflow = async (id, workflowData) => {
  const response = await axios.put(`${API_BASE_URL}${WORKFLOWS_PATH}/${id}`, workflowData);
  return response.data.data;
};

const deleteWorkflow = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}${WORKFLOWS_PATH}/${id}`);
  return response.data.data;
};

const getWorkflowEvents = async () => {
  const response = await axios.get(`${API_BASE_URL}${WEBHOOKS_PATH}/events`);
  return response.data.data;
};

const workflowService = {
  createWorkflow,
  getWorkflows,
  getWorkflowById, // <-- ADD THIS
  updateWorkflow,  // <-- ADD THIS
  deleteWorkflow,
  getWorkflowEvents,
};

export default workflowService;